export const config = {

  isOfflineMCU: false,
  isOffline: true,
  AppUse: 2, //1 - InstaVC(Intl), 2-InVC (MSoup), 3 - (Jitsi)

  mcuURLifOffline: "wss://mcu.peoplelinkvc.com:20072",
  sampleparticipantUrl:
    "https://instavc-content.s3-ap-southeast-1.amazonaws.com/sampleparticipants.xlsx",
  isClass: false,
  // defaultSubdomain: ["app", "test"],
  // enableBreakout: true,
  // domainUrl: "https://opvccicd.inclass.vc/api",
  domainUrl: "https://inclass.must.ac.tz/api",

  domain: "opvccicd",
  domainLogo: "/images/logos/inclass-new.png",
  instituteId: "ffef2441-f049-4930-8b5f-be306365ef0d",
  recodingServer : 'inclass.must.ac.tz/recording',
  // instituteId: "b26457db-bafe-47c2-8183-23a14909648d",
  helpCenterUrl: "https://help.instavc.com/inclass",
};

export var workspace = {
  peer: {
    url: "https://awspeer.instavc.com",
  },
};
